import cn from 'clsx'
import * as React from 'react'
import { Link } from 'react-router-dom'
import type { DropdownOption } from 'types/ui'
import TagSelector from 'components/common/tag-selector'
import FilterRow from '../filter-row'
type Props = {
  chosenTags: Array<string>
  updateSearchParams: (...args: Array<any>) => any
  isPhone?: boolean
  disabled: boolean
  scrollContainer: HTMLDivElement | null | undefined
}
export default class TagsFilter extends React.Component<Props> {
  _onSelectAllClick: () => any = () =>
    this.props.updateSearchParams({
      tags: [],
    })
  _onTagsFilterChange: (tags: Array<DropdownOption>) => any = (
    tags: DropdownOption[],
  ) =>
    this.props.updateSearchParams({
      tags: tags.map(t => t.value),
    })

  render(): React.ReactNode {
    const { chosenTags } = this.props
    const allTagsClass = cn('SearchResults_FilterOption', {
      'is-active': chosenTags.length === 0,
      SearchResults_FilterOption_Expandable_AlignTop: !this.props.isPhone,
    })
    const tagsClass = cn('SearchResults_FilterOption', {
      'is-active': chosenTags.length,
    })
    const selectedTagsCaption =
      chosenTags.length > 0
        ? `Selected tags: ${chosenTags.join(', ')}`
        : 'Selected tags'
    const tagFilter = this.props.isPhone ? (
      <Link className={tagsClass} to="/search/tag-filter">
        {selectedTagsCaption}
      </Link>
    ) : (
      <TagSelector
        disabled={this.props.disabled}
        onChange={this._onTagsFilterChange}
        className="SearchSelect"
        selectedTags={chosenTags}
        placeholder="Select tags"
        scrollContainer={this.props.scrollContainer}
      />
    )
    return (
      <FilterRow caption="Filter by tags:" reducedMargins>
        <a className={allTagsClass} onClick={this._onSelectAllClick}>
          Playlist Tags
        </a>
        {tagFilter}
      </FilterRow>
    )
  }
}
